'use es6';

import { Map as ImmutableMap } from 'immutable';
import resolveReport from './resolve';
import { getColumnsForTable } from './helpers';
import SalesAnalyticsReport from '../lib/salesAnalytics/SalesAnalyticsReport';
import { inferVisualization } from 'reporting-ui-components/reports/inferLogic/inferVisualization';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { TableVisualization } from 'reporting-visualizations/visualizations/table/tableRecords';
import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { getDrilldownColumns } from '../lib/salesAnalytics/drilldownColumns';
import { isTable, isSearch } from '../lib/salesAnalytics/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const getVisualization = (report, data, {
  onDrilldown
}) => {
  const primaryDataset = data.getIn(['primary', 'data']) || Dataset({});
  if (isTable(report)) {
    const columns = isSearch(report) ? getDrilldownColumns(report) : getColumnsForTable(report, data, onDrilldown);
    return TableVisualization({
      data: {
        primary: primaryDataset
      },
      columns
    });
  }
  return inferVisualization(report, data).set('events', {
    onPointClick: callWidgetDrilldown(report, onDrilldown)
  }).setIn(['layers', 0, 'color', 'order'], ImmutableMap({
    direction: 'ascending'
  }));
};
const Index = props => /*#__PURE__*/_jsx(SalesAnalyticsReport, Object.assign({}, props, {
  resolveReport: resolveReport,
  getVisualization: getVisualization
}));
export default Index;